var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArticleClean(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 150 150",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125 137.5H25C23.3424 137.5 21.7527 136.842 20.5806 135.669C19.4085 134.497 18.75 132.908 18.75 131.25V18.75C18.75 17.0924 19.4085 15.5027 20.5806 14.3306C21.7527 13.1585 23.3424 12.5 25 12.5H125C126.658 12.5 128.247 13.1585 129.419 14.3306C130.592 15.5027 131.25 17.0924 131.25 18.75V131.25C131.25 132.908 130.592 134.497 129.419 135.669C128.247 136.842 126.658 137.5 125 137.5ZM118.75 125V25H31.25V125H118.75ZM43.75 37.5H68.75V62.5H43.75V37.5ZM43.75 75H106.25V87.5H43.75V75ZM43.75 100H106.25V112.5H43.75V100ZM81.25 43.75H106.25V56.25H81.25V43.75Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticleClean);
export default __webpack_public_path__ + "static/media/article_clean.7e3ff44237758916afb79ad8aa823ed0.svg";
export { ForwardRef as ReactComponent };